(function () {
  'use strict';

  function matrix3dFromCorners(w, h, dst) {
    if (dst.length !== 4) throw new Error('dst must have 4 corners');
    var src = [[0,0],[w,0],[w,h],[0,h]];
    var A = [], B = [];
    for (var i = 0; i < 4; i++) {
      var sx = src[i][0], sy = src[i][1], dx = dst[i][0], dy = dst[i][1];
      A.push([sx, sy, 1, 0, 0, 0, -sx*dx, -sy*dx]); B.push(dx);
      A.push([0, 0, 0, sx, sy, 1, -sx*dy, -sy*dy]); B.push(dy);
    }
    var n = 8;
    var M = A.map(function (row, i) { return row.concat(B[i]); });
    for (var i = 0; i < n; i++) {
      var pivot = i;
      for (var k = i+1; k < n; k++) if (Math.abs(M[k][i]) > Math.abs(M[pivot][i])) pivot = k;
      var tmp = M[i]; M[i] = M[pivot]; M[pivot] = tmp;
      var pv = M[i][i];
      for (var k = i; k <= n; k++) M[i][k] /= pv;
      for (var k = 0; k < n; k++) {
        if (k === i) continue;
        var f = M[k][i];
        for (var j = i; j <= n; j++) M[k][j] -= f * M[i][j];
      }
    }
    var a = M[0][n], b = M[1][n], c = M[2][n], d = M[3][n];
    var e = M[4][n], f = M[5][n], g = M[6][n], h2 = M[7][n];
    return [a, d, 0, g, b, e, 0, h2, 0, 0, 1, 0, c, f, 0, 1];
  }

  function fontLabel(id) {
    return id.split('-').map(function (p) {
      return p.charAt(0).toUpperCase() + p.slice(1);
    }).join(' ');
  }

  function init() {
    var root = document.querySelector('[data-personalisation-root]');
    if (!root) return;
    var config;
    try { config = JSON.parse(root.getAttribute('data-config') || '{}'); }
    catch (e) { console.error('[perso] bad config JSON', e); return; }

    var input = root.querySelector('[data-perso-text]');
    var fontInputs = root.querySelectorAll('[data-perso-font]');
    var counter = root.querySelector('[data-perso-counter]');
    var addBtn = document.querySelector('[data-add-to-cart]') ||
                 document.querySelector('button[name="add"]');

    var galleryImgs = document.querySelectorAll('[data-product-image]');

    var maxChars = config.max_chars || 22;
    var color = config.text_color || '#2a1810';
    var zones = config.zones || [];

    function currentFont() {
      // Works for both <select data-perso-font> and legacy <input type="radio" data-perso-font>:
      // a select has .value directly; for radios we look up the checked one.
      var el = root.querySelector('select[data-perso-font]');
      if (el) return el.value || (config.default_font || 'caveat');
      var checked = root.querySelector('[data-perso-font]:checked');
      return checked ? checked.value : (config.default_font || 'caveat');
    }

    // Reusable canvas — measuring through scrollWidth on the flex overlay is
    // unreliable (flex item shrink + overflow:hidden interactions distort the
    // result). measureText on a Canvas2D context gives the natural pixel width
    // of the string at the requested font, independent of any layout box.
    var measureCanvas = document.createElement('canvas');
    var measureCtx = measureCanvas.getContext('2d');

    function measureLineWidth(text, fontFamily, fontSize) {
      // Match the cursive fallback used in the overlay CSS so the measurement
      // matches what the browser will actually paint.
      measureCtx.font = '400 ' + fontSize + 'px "' + fontFamily + '", cursive';
      return measureCtx.measureText(text).width;
    }

    // Auto-fit handles multi-line text (newlines from the textarea). We measure
    // the widest line and the total vertical extent (lineCount × lineHeight),
    // then pick the scale that fits both within the zone with some margin.
    function fitFontSize(overlay, srcW, srcH, baseFontSize, text, fontFamily) {
      if (!text) { overlay.style.fontSize = baseFontSize + 'px'; return; }
      var probe = 100;
      var lines = text.split('\n');
      var maxLineW = 0;
      lines.forEach(function (line) {
        var w = measureLineWidth(line, fontFamily, probe);
        if (w > maxLineW) maxLineW = w;
      });
      if (maxLineW <= 0) { overlay.style.fontSize = baseFontSize + 'px'; return; }
      // ~1.2x font-size per line is a safe height estimate across browsers.
      var lineHeightRatio = 1.2;
      var totalH = lines.length * probe * lineHeightRatio;
      var widthFit = (srcW * 0.9) / maxLineW;
      var heightFit = (srcH * 0.85) / totalH;
      var scale = Math.min(widthFit, heightFit);
      var fitted = Math.min(probe * scale, baseFontSize * 3);
      overlay.style.fontSize = fitted + 'px';
    }

    function updateOverlays() {
      var text = input.value;
      var font = currentFont();
      if (counter) counter.textContent = text.length + '/' + maxChars;
      if (addBtn) addBtn.disabled = text.trim().length === 0;
      // Sync the select's own font-family with the chosen option so the closed
      // dropdown shows the selected typeface, not the system default.
      var selectEl = root.querySelector('select[data-perso-font]');
      if (selectEl) selectEl.style.fontFamily = "'" + fontLabel(font) + "', cursive";

      galleryImgs.forEach(function (img) {
        var imgId = img.getAttribute('data-image-id');
        var zone = zones.find(function (z) { return z.image_id === imgId; });
        var wrapper = img.parentElement;
        if (!wrapper) return;
        var existing = wrapper.querySelector('.perso-overlay');
        if (!zone) { if (existing) existing.remove(); return; }

        var rect = img.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;
        var srcW = 200, srcH = 70;
        var dst = zone.corners.map(function (c) { return [c[0]*rect.width, c[1]*rect.height]; });
        var m = matrix3dFromCorners(srcW, srcH, dst);
        var baseFontSize = srcH * (zone.font_size_ratio || 0.06) * 14;

        var overlay = existing || document.createElement('div');
        overlay.className = 'perso-overlay';
        overlay.style.cssText =
          'position:absolute;left:0;top:0;width:'+srcW+'px;height:'+srcH+'px;' +
          'transform-origin:0 0;transform:matrix3d('+m.join(',')+');' +
          'pointer-events:none;display:flex;flex-direction:column;align-items:' +
          (zone.text_align === 'left' ? 'flex-start' : zone.text_align === 'right' ? 'flex-end' : 'center') + ';' +
          'justify-content:center;text-align:' + (zone.text_align || 'center') + ';' +
          'color:' + color + ';font-family:"' + fontLabel(font) + '",cursive;font-weight:400;' +
          'line-height:1.2;overflow:hidden;white-space:nowrap;' +
          'font-size:' + baseFontSize + 'px;z-index:2';
        // Render each newline-separated line as its own flex item so the
        // column-direction stacking actually produces multiple visual lines.
        overlay.innerHTML = '';
        text.split('\n').forEach(function (line) {
          var lineEl = document.createElement('div');
          // Empty line → preserve height with a non-breaking space.
          lineEl.textContent = line.length === 0 ? ' ' : line;
          overlay.appendChild(lineEl);
        });
        if (!existing) {
          wrapper.appendChild(overlay);
        }
        fitFontSize(overlay, srcW, srcH, baseFontSize, text, fontLabel(font));
      });
    }

    // If the product is already in the cart with personalization (e.g. user
    // is "re-opening" it from the cart), pre-fill the textarea and font select
    // from the most recent matching line item. The cart.js endpoint returns
    // products' handles in each item.
    function prefillFromCart() {
      var pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (!pathMatch) return;
      var handle = pathMatch[1];
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          // Take the LAST matching line — newest customization wins.
          var match = null;
          cart.items.forEach(function (item) { if (item.handle === handle) match = item; });
          if (!match || !match.properties) return;
          var savedText = match.properties['personalization'];
          var savedFont = match.properties['font'];
          if (typeof savedText === 'string' && input.value === '') {
            input.value = savedText;
          }
          if (savedFont) {
            var selectEl = root.querySelector('select[data-perso-font]');
            if (selectEl) selectEl.value = savedFont;
          }
          updateOverlays();
        })
        .catch(function () { /* silent — pre-fill is best-effort */ });
    }
    prefillFromCart();

    input.addEventListener('input', updateOverlays);
    fontInputs.forEach(function (f) { f.addEventListener('change', updateOverlays); });
    window.addEventListener('resize', updateOverlays);
    // Re-render après chargement des images + des fonts (sinon mesure faite
    // avec les metrics du fallback puis re-jouée quand la police arrive).
    Promise.all(Array.from(galleryImgs).map(function (i) {
      return i.complete ? Promise.resolve() : new Promise(function (res) { i.addEventListener('load', res, { once: true }); });
    })).then(updateOverlays);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateOverlays);
    }

    updateOverlays();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-personalisation-root]')) {
      init();
    }
  });
})();
